/**
 * Fetch currently used language from browser
 * @return {string} 'fi'|'en' etc locale string
 */

import { isLocale } from 'Utility/typeGuards';

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const browserLanguage = (navigator.languages[0] ?? navigator.language ?? navigator.userLanguage)
  .toLowerCase()
  .split(/[_-]+/)[0];

const neuroLanguage: Locale = isLocale(browserLanguage) ? browserLanguage : 'fi';

export default neuroLanguage;
